import ModalHeader from '@/components/modal/ModalHeader.tsx';
import React from 'react';
import Modal from '@/components/modal/Modal.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { FormProvider, useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import {
  LongTextCustomFieldFormData,
  LongTextCustomFieldInputData,
  longTextCustomFieldSchema,
} from '@/features/dashboard/tourCustomFields/schemas/longTextCustomFieldSchema.ts';
import { tourCustomFieldsRoute } from '@/features/dashboard/tourCustomFields/routes/tourCustomFieldsRoute.ts';
import LongTextCustomFieldForm from '@/features/dashboard/tourCustomFields/components/LongTextCustomFieldForm.tsx';
import useUpdateCustomField from '@/features/dashboard/tourCustomFields/hooks/useUpdateCustomField.ts';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import { LongTextCustomFieldDefinitionDto } from '@/features/dashboard/tourCustomFields/types/LongTextCustomFieldDefinitionDto.ts';

const LongTextCustomFieldEditModal = ({
  onClose,
  fieldDef,
}: {
  onClose: () => void;
  fieldDef: LongTextCustomFieldDefinitionDto;
}) => {
  const { tourId } = tourCustomFieldsRoute.useParams();
  const form = useForm<LongTextCustomFieldInputData>({
    resolver: debugZodResolver(longTextCustomFieldSchema),
    defaultValues: {
      type: FieldType.LONG_TEXT,
      fieldName: fieldDef.name,
      isFieldMandatory: fieldDef.required,
      hint: fieldDef.hint,
      placeholder: fieldDef.placeholder,
      isCharacterLimitEnabled:
        fieldDef.maxChars !== null && fieldDef.minChars !== undefined,
      maxChars: fieldDef.maxChars,
      minChars: fieldDef.minChars,
      isChangeDefaultRowsNumber: fieldDef.defaultHeight !== 3,
      rowsNumber: fieldDef.defaultHeight,
    },
  });

  const updateCustomField = useUpdateCustomField(tourId, fieldDef.id);

  const handleSubmit = (data: LongTextCustomFieldFormData) => {
    updateCustomField.mutate(data, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <Modal onClose={onClose} isDirty={form.formState.isDirty}>
      <ModalHeader title="Edytuj pole tekstowe długie" onClose={onClose} />
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <LongTextCustomFieldForm />
          <ModalFooter>
            <ActionButton tone="outline" size="sm" onClick={onClose}>
              Zamknij
            </ActionButton>
            <ActionButton tone="accent" size="sm" type="submit">
              Zapisz
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default LongTextCustomFieldEditModal;
